<div class="footer">
  <p>&nbsp;</p>
  <div class="copyright">
    <p>Circana &copy; {{ year }}</p>
  </div>
</div>
